export const FETCH_HABIT_START = 'FETCH_HABIT';
export const FETCH_HABIT_ERROR = 'FETCH_HABIT_ERROR';
export const FETCH_HABIT_SUCCESS = 'FETCH_HABIT_SUCCESS';
export const HABIT_PUSH = 'HABIT_PUSH';
export const HABIT_UPDATE = 'HABIT_UPDATE';
export const HABIT_ARCHIVE = 'HABIT_ARCHIVE';
